/** @jsx jsx */
import { jsx, Box, Container, Flex } from 'theme-ui';
/* eslint-disable react/no-danger */
import React from 'react';

// Node Types
import { SectionComponent } from '@codersclan/gatsby-theme-airfleet/src/@types';

// Node Components
import FluidImage from '@codersclan/gatsby-theme-airfleet/src/components/fluidImage';

// Types
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';

// Styles
import { baseStyle } from './style';

interface FullImageProps extends Section {
  fullImage: {
    fullImage: ImageType;
  };
}

const FullImage: SectionComponent<FullImageProps> = React.memo(
  ({ fullImage }) => (
    <Container>
      <FluidImage {...fullImage.fullImage} sx={baseStyle.image} />
    </Container>
  ),
);

export default FullImage;
